import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcMarketingColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 10,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 7,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 4,
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.2071 9.49994L14.3536 14.3535L13.6465 13.6464L18.5 8.79284V6.73412C18.5 6.58573 18.5659 6.44501 18.6799 6.35001L21.172 4.2733C21.3022 4.16475 21.5 4.25738 21.5 4.42694V6.49994L23.6336 6.92665C23.7902 6.95797 23.8487 7.15123 23.7358 7.26418L21.6464 9.35349C21.5527 9.44726 21.4255 9.49994 21.2929 9.49994H19.2071Z",
			fill: "#8C81F7"
		})
	]
});
export default SvgIcMarketingColor;
